/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject, Injectable } from '@angular/core';

import { iif, Observable, of } from 'rxjs';
import { defaultIfEmpty, filter, map, switchMap, take } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { DigitizePointConfigState } from './state/digitize-point-config.state';
import { DigitizableLayer } from './state/digitize-point-config.model';

@Injectable({providedIn: 'root'})
export class DigitizePointConfigService {

    loaded$: Observable<boolean> = inject(Store).select(DigitizePointConfigState.loaded);
    layers$: Observable<DigitizableLayer[]> = inject(Store).select(DigitizePointConfigState.layers);

    constructor() {}

    public getLayer(layerName): Observable<DigitizableLayer> {
        const empty: DigitizableLayer = {
            create: false,
            delete: false,
            move: false,
            displayName: '',
            keyField: '',
            layer: layerName,
            dataForm: '',
            latField: '',
            lonField: '',
        };
        const whenLoaded$ = this.layers$.pipe(
            take(1),
            map((layers: DigitizableLayer[]) => layers.find(l => l.layer === layerName)),
            filter(layer => layer !== undefined),
            defaultIfEmpty(empty)
        );
        return this.loaded$.pipe(
            switchMap(loaded => iif(() => loaded, whenLoaded$, of(null)))
        );
    }
}
